import CancelRounded from "@mui/icons-material/CancelRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import {
  Autocomplete,
  Box,
  FormHelperText,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import { useAppDispatch } from "../../../hooks/useRedux";
//   import {
//     setCargoGroup,
//     setCargoType,
//     setDestination,
//     setOrigin,
//     setPackageType,
//   } from "../../../redux/features/receiveCargoSlice";

interface IOption {
  label?: string;
  value?: number;
}

interface AutoCompleteProps {
  options?: IOption[];
  value?: IOption | IOption[] | null;
  setValue?: (selected: IOption, type: string | undefined) => void;
  inputValue?: string;
  setInputValue?: React.Dispatch<React.SetStateAction<string>>;
  type?: string;
  placeHolder?: string;
  defaultValue?: string | null;
  disabled?: boolean;
  width?: string;
  height?: string;
  optionHeight?: string;
  loading?: boolean;
  borderColor?: string;
  borderRadius?: string;
  multiple?: boolean;
  menuIcon?: JSX.Element;
  innerIcon?: JSX.Element;
  outerIcon?: JSX.Element;
  mb?: string;
  error?: boolean;
  errorMessage?: any;
  flex?: 1 | 0;
  maxL?: number;
}

const CustomAutoComplete = (props: AutoCompleteProps) => {
  const dispatch = useAppDispatch();

  const theme = useTheme();
  const {
    value = null,
    setValue,
    type,
    width = "100%",
    height = "48px",
    optionHeight = "20px",
    loading = true,
    disabled,
    borderColor = "textColor.light",
    borderRadius = "10px",
    options = [],
    multiple = false,
    placeHolder = "",
    menuIcon,
    innerIcon,
    outerIcon,
    mb = "12px",
    error,
    errorMessage,
    setInputValue,
    inputValue,
    flex,
    maxL,
  } = props;

  // const handleChange = (value: any) => {
  //   console.log(value.value);
  // };

  // const handleChange = (event: any) => {
  //   if (type === "cargoType") {
  //     dispatch(setCargoType(event.target.innerText));
  //   }
  //   if (type === "origin") {
  //     dispatch(setOrigin(event.target.innerText));
  //   }
  //   if (type === "destination") {
  //     dispatch(setDestination(event.target.innerText));
  //   }
  //   if (type === "cargoGroup") {
  //     dispatch(setCargoGroup(event.target.innerText));
  //   }
  //   if (type === "packageType") {
  //     dispatch(setPackageType(event.target.innerText));
  //   }
  // };

  return (
    <>
      <Box
        sx={{
          flex: flex,
          width: width,
          "& .MuiAutocomplete-endAdornment": {
            left: "4px",
            right: "auto !IMPORTANT",
            // top: "7px",
          },
          "& .MuiAutocomplete-root": {
            marginBottom: mb,
          },
          "& .MuiAutocomplete-clearIndicator": {
            visibility: value ? "visible !IMPORTANT" : "hidden",
          },
          "& .MuiInputBase-root": {
            height: height,
            borderRadius: borderRadius,
            boxShadow: "0px 2px 15px 0px rgba(0, 0, 0, 0.06)",
          },

          "& fieldset": {
            borderColor: theme.palette.textColor.light,
          },
          "& fieldset:hover": {
            border: "1px solid red",
          },
          "& input": {
            color: "textColor.main",
            fontSize: "14px",
          },
        }}
      >
        <style>
          {`
          .base-Popper-root div {
                  max-height:150px !IMPORTANT;
                              


                  }
                              .MuiPopper-root{
                              direction: rtl !IMPORTANT;
                              font-size:14px !IMPORTANT;
                              }
          `}
        </style>
        <Autocomplete
          dir="rtl"
          noOptionsText={
            <>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                درحال جستجو...
              </Typography>
            </>
          }
          disabled={disabled}
          sx={{
            direction: "rtl",
            width: "100%",
            mb: mb,
            "& .MuiInputBase-formControl": {
              padding: `4px 0px 4px 8px !IMPORTANT`,
            },
          }}
          limitTags={8}
          multiple={multiple}
          // freeSolo
          // defaultValue={defaultValue}
          onChange={(e: any, newValue: any) => {
            if (setValue) {
              setValue(newValue, type);
            }
          }}
          isOptionEqualToValue={(option: IOption, value: IOption) =>
            option.value === value.value
          }
          onInputChange={(event, newInputValue: string, type) => {
            if (setInputValue) {
              if (maxL) {
                if (newInputValue.length <= maxL) {
                  setInputValue(newInputValue);
                } else {
                }
              } else {
                setInputValue(newInputValue);
              }
            }
          }}
          inputValue={inputValue}
          value={value ? value : null}
          popupIcon={
            !value && (
              <ExpandMoreRoundedIcon
                sx={{ color: borderColor, fontSize: "22px" }}
              />
            )
          }
          clearIcon={
            <CancelRounded sx={{ color: "error.main", fontSize: "28px" }} />
          }
          options={options.map((option) => option)}
          // renderTags={(value, getTagProps) =>
          //   value.map((option, index) => (
          //     <Chip
          //       // avatar={<Box sx={{ ml: "4px", mb: "2px" }}>zz</Box>}
          //       deleteIcon={
          //         <CloseRoundedIcon
          //           sx={{
          //             fontSize: "16px !IMPORTANT",
          //             color: "#424242 !IMPORTANT",
          //           }}
          //         />
          //       }
          //       sx={{ borderRadius: "8px" }}
          //       variant="outlined"
          //       label={option}
          //       {...getTagProps({ index })}
          //     />
          //   ))
          // }
          renderInput={(params) => {
            const innerIcons = outerIcon
              ? {
                  startAdornment: (
                    <InputAdornment position="start">
                      {innerIcon}
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      {outerIcon}
                    </InputAdornment>
                  ),
                }
              : {
                  startAdornment: (
                    <InputAdornment position="start">
                      {innerIcon}
                    </InputAdornment>
                  ),
                };
            const newParams = {
              ...params,
              InputProps: {
                ...params.InputProps,
                placeholder: placeHolder,
                ...innerIcons,
              },
            };

            return (
              <TextField
                sx={{
                  'input[type="search"]::-webkit-search-cancel-button': {
                    "-webkit-appearance": "none",
                    appearance: "none",
                  },
                  'input[type="search"]::-ms-clear': {
                    display: "none",
                  },
                  'input[type="search"]::-ms-reveal': {
                    display: "none",
                  },
                  'input[type="search"]::-webkit-search-decoration': {
                    display: "none",
                  },
                }}
                type="search"
                error={error}
                helperText={
                  error && (
                    <FormHelperText
                      style={{
                        padding: "0px",
                        margin: "0px",
                        color: "red",
                        direction: "rtl",
                        textAlign: "right",
                        fontSize: 13,
                      }}
                    >
                      {errorMessage}
                    </FormHelperText>
                  )
                }
                {...newParams}
              />
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                paddingTop: "4px",
                paddingBottom: "4px",
                // border: "1px solid gray",
              }}
            >
              {/* {selected && (
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginLeft: -14 }}
                  checked={selected}
                />
              )} */}
              <Typography
                sx={{ ml: "auto", color: "textColor.main", fontSize: "14px" }}
              >
                {option.label}
              </Typography>
              {/* {menuIcon && (
                <Box sx={{ ml: "-10px", mr: "8px" }}>{menuIcon}</Box>
              )} */}
            </li>
          )}
        />
      </Box>
    </>
  );
};

export default CustomAutoComplete;
